import { isEqual } from 'lodash';

import BaseDropdown from './dropdown';

class NetworksDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'networks';
    // List item can be targeted by the network name, e.g. $('.dropdown-item.narrativ')
    this.identifierField = 'name';
    this.dropdownDiv = null;
    this.hasSearch = false;

    this.previousNetworks = this.props.items;
    this.state = {
      opened: false,
      focusIndex: null,
      label: this.getLabel(this.props.items),
      networks: this.props.items,
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.items, this.props.items)) {
      this.setState({ label: this.getLabel(this.props.items) });
    }
  }

  update() {
    let { networks } = this.state;
    if (!networks.filter(network => network.selected).length) {
      networks = networks.map(network => {
        network.selected = true;
        return network;
      });
    }

    const selectedNetworks = networks
      .filter(network => network.selected)
      .map(network => network.label)
      .join(',');
    const gaLabel = `${this.props.gaEvent.label} ${selectedNetworks}`;
    this.AnalyticService.trackEvent(this.props.gaEvent.category, 'Execute', gaLabel);

    this.setState({ label: this.getLabel(networks) });
    this.props.updateNetworks(networks);
  }

  /* Helper functions */
  getLabel(networks) {
    let numSelected = 0;
    let label;

    networks.forEach(network => {
      if (network.selected) numSelected += 1;
    });

    if (numSelected === 0 || numSelected === networks.length) {
      label = 'All Networks';
    } else if (numSelected === 1) {
      label = networks.find(network => network.selected).label;
    } else {
      label = `${numSelected} Networks`;
    }

    return label;
  }
}

export default NetworksDropdown;
